import styled from "styled-components";

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 auto;
  min-width: 0; /* Allows text truncation */
`;

export const RightSpace = styled.div`
  display: flex;
  flex-direction: row;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
  min-width: fit-content;
  align-self: center;
`;

export const AssisnedUsersContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  justify-content: flex-start;
`;